//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalUnitsToBeCreatedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Units To Be Created' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalUnitsToBeCreatedWidget;
